import React from 'react';
import { BookOpen, CheckCircle2, FileStack, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

const STATUS = {
  draft: 'Draft', drafting: 'Drafting', in_review: 'In review',
  approved: 'Approved', published: 'Published', failed: 'Needs attention',
};

const STATUS_STYLE = {
  draft: 'border-zinc-400/40 bg-zinc-500/10 text-zinc-700',
  drafting: 'border-amber-400/40 bg-amber-500/10 text-amber-800',
  in_review: 'border-sky-400/40 bg-sky-500/10 text-sky-800',
  approved: 'border-emerald-400/40 bg-emerald-500/10 text-emerald-800',
  published: 'border-rose-400/40 bg-rose-500/10 text-rose-800',
  failed: 'border-red-400/40 bg-red-500/10 text-red-800',
};

export const ManuscriptLibraryCard = ({ manuscript, assetUrl, busy, onLoad }) => {
  const loaded = Boolean(manuscript.loaded_project_id);
  return (
    <article className="grid grid-cols-[5.5rem_minmax(0,1fr)] gap-4 rounded-md border border-border/80 bg-card p-3 shadow-sm transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:border-primary/50 hover:shadow-lg" data-testid={`manuscript-card-${manuscript.id}`}>
      <div className="aspect-[2/3] overflow-hidden rounded-sm border border-border bg-[#2f3b34]">
        {manuscript.cover_front_url ? (
          <img src={assetUrl(manuscript.cover_front_url)} alt={`${manuscript.title} cover`} className="h-full w-full object-cover object-center" data-testid={`manuscript-cover-${manuscript.id}`} />
        ) : (
          <div className="flex h-full flex-col justify-between p-2 text-[#f5e9c8]"><FileStack className="h-5 w-5" /><span className="line-clamp-4 font-serif text-sm leading-4">{manuscript.title}</span></div>
        )}
      </div>
      <div className="flex min-w-0 flex-col">
        <div className="flex flex-wrap items-start justify-between gap-2">
          <div className="min-w-0"><h2 className="truncate font-serif text-xl font-semibold" data-testid={`manuscript-title-${manuscript.id}`}>{manuscript.title}</h2><p className="truncate text-xs text-muted-foreground">{manuscript.pseudonym_name || 'Crown & Rose Studio'}</p></div>
          <span className={`rounded-sm border px-2 py-0.5 text-[10px] font-semibold uppercase ${STATUS_STYLE[manuscript.status] || STATUS_STYLE.draft}`} data-testid={`manuscript-status-${manuscript.id}`}>{STATUS[manuscript.status] || manuscript.status}</span>
        </div>
        <div className="mt-4 text-xs text-muted-foreground" data-testid={`manuscript-progress-${manuscript.id}`}>{manuscript.chapters_drafted} of {manuscript.chapters_total} chapters drafted</div>
        <div className="mt-auto pt-4">
          <Button type="button" size="sm" className="w-full gap-2" variant={loaded ? 'outline' : 'default'} onClick={() => onLoad(manuscript)} disabled={busy} data-testid={loaded ? `open-loom-editor-btn-${manuscript.id}` : `load-editable-copy-btn-${manuscript.id}`}>
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : loaded ? <CheckCircle2 className="h-4 w-4 text-emerald-600" /> : <BookOpen className="h-4 w-4" />}
            {loaded ? 'Open working copy' : 'Load editable copy'}
          </Button>
        </div>
      </div>
    </article>
  );
};